import './get_udid.css';
import Header from '../../components/HeaderUDID';
import React, { useContext, useEffect, useState} from 'react';
import { LangContext } from '../../context';
import translations from '../../utils/Translations';
import DeviceCard from '../../components/DeviceCard';
import ModalUDID from '../../components/ModalUDID';
import AppModal from '../../components/AppModal';
import { wait } from '@testing-library/user-event/dist/utils';
import { useTitle } from '../../hooks/useTitle';

const GetUDID = () => {
    useTitle('UDID Device Status')
    const Lang = useContext(LangContext);
    const [devices, setDevices] = useState([])
    const [modal, setModal] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [showModalApp, setShowModelApp] = useState(false)

    async function fetchDeviceData (udid) {

        try {
        const response = await fetch(`https://cert.ipa.su/${udid}`, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {

            return {}
        }
        const data = await response.json()

        
        return data
        } catch (error) {
            showNotification('Ошибка получения данных');
            wait(2)
            return {}
        } 
    };
    const t = (key) => {
        return translations[Lang.Lang]?.[key] || key;
    };
    useEffect(() => {
        const loadTelegramScript = () => {
     
        
            const existingScript = document.querySelector('script[src="https://telegram.org/js/telegram-web-app.js"]');
            if (existingScript) {
                existingScript.remove();
            }
            const script = document.createElement('script');
            script.src = 'https://telegram.org/js/telegram-web-app.js';
            document.head.appendChild(script);

            };
        loadTelegramScript()
        })
    //<script src="https://telegram.org/js/telegram-web-app.js"></script>
    function showNotification(message, type = 'info') {
            const notification = document.createElement('div');
            notification.style.cssText = `
                position: fixed;
                top: 20px;
                right: 20px;
                padding: 15px 25px;
                border-radius: 10px;
                color: white;
                font-weight: 600;
                z-index: 10000;
                animation: slideInRight 0.3s ease;
                max-width: 300px;
                box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
            `;
            
            if (type === 'success') {
                notification.style.background = 'linear-gradient(45deg, #51cf66 0%, #40c057 100%)';
                notification.innerHTML = `<i class="fas fa-check-circle"></i> ${message}`;
            } else if (type === 'error') {
                notification.style.background = 'linear-gradient(45deg, #ff4757 0%, #c44569 100%)';
                notification.innerHTML = `<i class="fas fa-times-circle"></i> ${message}`;
            } else {
                notification.style.background = 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)';
                notification.innerHTML = `<i class="fas fa-info-circle"></i> ${message}`;
            }
            
            document.body.appendChild(notification);
            
            
            setTimeout(() => {
                notification.style.animation = 'slideOutRight 0.3s ease';
                setTimeout(() => {
                    if (document.body.contains(notification)) {
                        document.body.removeChild(notification);
                    }
                }, 300);
            }, 4000);
        }

    function openModal(id) {

        const device = devices.find(item => item.id === id);
        
        const modalData = {
            id: device.id,
            name: device.name,
            date: device.date,
            udid: device.udid,
            apps: device.apps
        }
        setModal(modalData)
        setShowModal(true)
    }
    async function searchDevice(event) {
            event.preventDefault();
            
            const udidInput = document.getElementById('udid-input');
            const searchBtn = document.getElementById('search-btn');
            const searchResults = document.getElementById('search-results');
            const searchResultsTitle = document.getElementById('search-results-title');
            const searchResultsText = document.getElementById('search-results-text');
            const udid = udidInput.value.trim();
            
            if (!udid) {
                showNotification('Пожалуйста, введите UDID устройства', 'error');
                return;
            }
            
            const udidPattern = /^[a-fA-F0-9-]+$/;
            if (!udidPattern.test(udid) || ![25, 40, 60].includes(udid.length)) {
                showNotification('Неверный формат UDID. Пример: 00008120-0009353426E3C01E', 'error');
                return;
            }
            
            searchBtn.classList.add('searching');
            searchBtn.innerHTML = '<div class="loading-spinner"></div><span>Поиск...</span>';
            searchBtn.disabled = true;
            
            setTimeout(async () => {
                const data = await fetchDeviceData(udid)

                const devices = data['certificates'];
                
                if (devices && devices.length > 0) {

                    const deviceCount = devices.length;

                    
                    searchResults.className = 'search-results show found';
                    searchResultsTitle.innerHTML = `<i class="fas fa-check-circle"></i>Найдено сертификатов: ${deviceCount}`;
                    searchResultsText.textContent = `UDID ${udid} найден в системе`;
                    let dispayDevices = []
                    devices.forEach((device, index) => {

                        dispayDevices.push(
                            {
                                id: device.id,
                                status: device.status, 
                                udid: udid,
                                name: device.name,
                                date: device.date,
                                countdown: device.countdown,
                                revokeDate: device.revokeDate,
                                instructionUrl: device.instruction_url,
                                apps: device.apps
                            }
                        )
                    });

                    setDevices(dispayDevices)
                    const foundCards = document.querySelectorAll(`[data-udid="${udid}"]`);
               
                    
                    if (foundCards.length > 0) {
                        setTimeout(() => {
                            foundCards[0].scrollIntoView({ 
                                behavior: 'smooth', 
                                block: 'center' 
                            });
                        }, 500);
                    }
                    
                    showNotification(`Найдено ${deviceCount} сертификат(а)`, 'success');
                    
                } else {
                    setDevices([])
                    searchResults.className = 'search-results show not-found';
                    searchResultsTitle.innerHTML = '<i class="fas fa-times-circle"></i> Устройство не найдено';
                    searchResultsText.textContent = `UDID ${udid} не найден в системе`;
                    
                    // Показать все карточки обратно

                    
                    showNotification('Устройство не найдено в системе', 'error');
                }
                
                // Восстановить кнопку поиска
                searchBtn.classList.remove('searching');
                searchBtn.innerHTML = '<i class="fas fa-search"></i><span>Проверить</span>';
                searchBtn.disabled = false;
                
            }, 1500); // Симуляция задержки поиска
        }

    return (
        
        <div className="container">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

            <Header t={t} isFullNav={true}/>
            <div className="search-section">
            <div className="search-title">
                <h2><i className="fas fa-search"></i>{t('fa_search')}</h2>
                <p>{t("fa_search_p")}</p>
            </div>
            
            <form className="search-form" onSubmit={searchDevice}>
                <input 
                    type="text" 
                    className="search-input" 
                    id="udid-input"
                    placeholder={t('search_placeholder')}
                    maxLength="40"
                />
                <button type="submit" className="search-btn" id="search-btn">
                    <i className="fas fa-search"></i>
                    <span>{t('search')}</span>
                </button>
            </form>
            
            <div className="search-results" id="search-results">
                <div className="search-results-title" id="search-results-title"></div>
                <div className="search-results-text" id="search-results-text"></div>

            </div>

           
            </div>
            <div className="device-grid" id="device-grid">
                {devices.map((device) => (
                    <DeviceCard 
                        key={device.id}
                        status={device.status}
                        udid={device.udid}
                        name={device.name}
                        reg_date={device.date}
                        countdown={device.countdown}
                        revokeDate={device.revokeDate}
                        t={t}
                        openModalCard={() => openModal(device.id)}
                        setShowModelApp={setShowModelApp}
                        setShowModal={setShowModal}
                        showModal={showModal}
                        setModal={setModal}
                        instructionUrl={device.instructionUrl}
                        
                    />
                ))}
            </div>

            {(showModal && modal)? <ModalUDID t={t} id={modal.id} name={modal.name} reg_date={modal.date} udid={modal.udid} setShowModal={setShowModal} showModal={showModal} showNotification={showNotification}/> : ""}
            {(showModalApp && modal) ? <AppModal showModalApp={showModalApp} setShowModelApp={setShowModelApp} t={t} apps={modal.apps} udid={modal.udid} certId={modal.id} showNotification={showNotification}/> : ""}
        </div>

    )
    
}

export default GetUDID;